module.exports = __webpack_public_path__ + "static/media/contactMobile.d2c61372.jpg";